/**
 * RegionEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { RegionTypeEntity } from "../RegionTypeEntity";
import { RegionEntity } from "../RegionEntity";
import { MapEntity } from "../MapEntity";
import { RegionMemberEntity } from "../RegionMemberEntity";
import { VisitEntity } from "../VisitEntity";
import { PlanningEventGroupEntity } from "../PlanningEventGroupEntity";
import { DocumentEntity } from "../DocumentEntity";
import { ReportEntity } from "../ReportEntity";
declare global {
    interface EntityTypeMap {
        Region: RegionEntity;
    }
}
export abstract class RegionGeneratedEntity extends BaseEntity {
    public abstract regionId: string;
    public abstract templateId: string | null;
    public abstract name: string | null;
    public abstract text: string | null;
    public abstract isHandedOver: boolean;
    public abstract handedOverOn: Date | null;
    public abstract project: ProjectEntity;
    public abstract type: RegionTypeEntity | null;
    public abstract parentRegion: RegionEntity | null;
    public abstract readonly childrenRegions: ReadonlyArray<RegionEntity>;
    public abstract readonly maps: ReadonlyArray<MapEntity>;
    public abstract readonly members: ReadonlyArray<RegionMemberEntity>;
    public abstract readonly visits: ReadonlyArray<VisitEntity>;
    public abstract readonly planningEventGroups: ReadonlyArray<PlanningEventGroupEntity>;
    public abstract readonly documents: ReadonlyArray<DocumentEntity>;
    public abstract readonly reports: ReadonlyArray<ReportEntity>;
}
